{
  "name": "@kubb/cli",
  "version": "3.16.1",
  "description": "Command-line interface for Kubb, enabling easy generation of TypeScript, React-Query, Zod, and other code from OpenAPI specifications.",
  "keywords": [
    "cli",
    "command-line",
    "typescript",
    "openapi",
    "swagger",
    "code-generator",
    "codegen",
    "plugins",
    "kubb"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/kubb-labs/kubb.git",
    "directory": "packages/cli"
  },
  "license": "MIT",
  "author": "stijnvanhulle",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs",
      "default": "./dist/index.cjs"
    }
  },
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "./dist/index.d.ts",
  "bin": {
    "kubb": "bin/kubb.cjs"
  },
  "files": [
    "src",
    "dist",
    "bin",
    "!/**/**.test.**",
    "!/**/__tests__/**"
  ],
  "scripts": {
    "build": "tsup",
    "clean": "npx rimraf ./dist",
    "lint": "bun biome lint .",
    "lint:fix": "bun biome lint--fix --unsafe .",
    "release": "pnpm publish --no-git-check",
    "release:canary": "bash ../../.github/canary.sh && node ../../scripts/build.js canary && pnpm publish --no-git-check",
    "start": "tsup --watch",
    "test": "vitest --passWithNoTests",
    "typecheck": "tsc -p ./tsconfig.json --noEmit --emitDeclarationOnly false"
  },
  "dependencies": {
    "@kubb/core": "workspace:*",
    "@kubb/ui": "workspace:*",
    "chokidar": "^4.0.3",
    "citty": "^0.1.6",
    "cli-progress": "^3.12.0",
    "consola": "^3.4.2",
    "cosmiconfig": "^9.0.0",
    "execa": "^9.6.0",
    "gradient-string": "^3.0.0",
    "jiti": "^2.4.2",
    "latest-version": "^9.0.0",
    "open": "^10.2.0",
    "semver": "^7.7.2",
    "string-argv": "^0.3.2"
  },
  "devDependencies": {
    "@kubb/config-ts": "workspace:*",
    "@kubb/config-tsup": "workspace:*",
    "@kubb/mcp": "workspace:*",
    "@kubb/oas": "workspace:*",
    "@kubb/plugin-oas": "workspace:*",
    "@types/cli-progress": "^3.11.6",
    "@types/node": "catalog:",
    "@types/semver": "^7.7.0",
    "source-map-support": "^0.5.21",
    "tsup": "catalog:",
    "typescript": "catalog:"
  },
  "engines": {
    "node": ">=20"
  },
  "preferGlobal": true,
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  }
}
